<template>
    <div class="area">
        <el-radio-group v-model="inout" @change="guo">
            <el-radio :label="1">国内</el-radio>
            <el-radio :label="2">国外</el-radio>
        </el-radio-group>
        <br v-if="flag == 'app'" />
        <el-select v-model="sheng" @change="shengChage" placeholder="请选择省" style="width:120px">
            <el-option value="">请选择</el-option>
            <el-option v-for="(item, index) in shengData" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <br v-if="flag == 'app'" />
        <el-select v-model="shi" @change="shiChage" placeholder="请选择市" style="width:120px">
            <el-option value="">请选择</el-option>
            <el-option v-for="(item, index) in shiData" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <br v-if="flag == 'app'" />
        <el-select v-model="xian" @change="xianChage" v-if="inout == '1'" placeholder="请选择县/区" style="width:120px;">
            <el-option value="">请选择</el-option>
            <el-option v-for="(item, index) in xianData" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <br v-if="flag == 'app'" />
        <el-input v-model="zhen" placeholder="请输入镇/村"  :style="{ width: flag == 'app' ? '90%' : '120px',}"   @input="zhenChage"></el-input>
        <br />
        <br v-if="flag == 'app'" />
        <div style="position: relative;">
            <!-- {{ propskey == "qs" ? "方位" : "自录地址" }} -->
            自录地址 &nbsp;&nbsp;&nbsp;
            <el-input
                v-model="dizhi"
                placeholder="点击选择自录地址并定位"
                :style="{ width: flag == 'app' ? '80%' : '300px', 'margin-top': '10px' }"
                @input="handlerChange"
                @keyup.enter.native="mapFun"
            ></el-input>
            <!-- :style="{ '': true, 'width:80%': flag == 'app', 'width:200px': flag == 'pc' }" -->
            <a href="javascript:;" @click="mapOpen()" style="position: absolute; left: 400px; top: 10px; color: #409EFF;">
                <!-- {{ propskey == "qs" ? "点击选择方位" : "点击选择自录地址" }} -->
                点击选择自录地址
            </a>
        </div>
        <!-- <div v-if="propsdwShow">
            定位 &nbsp;&nbsp;
            <el-input v-model="dtdz" @focus="mapOpen()" style="width:588px;margin-top:10px; cursor: pointer;" placeholder="点击定位"></el-input>
        </div> -->

        <el-dialog :visible.sync="dialogMap" :fullscreen="true" class="map">
            <vmap @getLnglat="getPosi" :data="dtdz" :dzData="dizhi"></vmap>
        </el-dialog>
    </div>
</template>
<script>
import api from "@/request/api";
import vmap from "@/components/vmap.vue";

export default {
    // props: ["data"],
    props: {
        propsinorout: {
            type: Number
        },
        propssheng: {
            type: String
        },
        propsshi: {
            type: String
        },
        propsxian: {
            type: String
        },
        propszhen: {
            type: String
        },
        propsdizhi: {
            type: String
        },
        propsdtdz: {
            type: String
        },
        propskey: {
            type: String
        },
        propskeyType: {
            type: String
        },
        propskeyInd: {
            type: Number
        },
        propsdwShow: {
            type: Boolean
        }
    },
    data() {
        return {
            inout: 1,
            shengData: [],
            shiData: [],
            xianData: [],
            sheng: "",
            shi: "",
            xian: "",
            zhen: "",
            dizhi: "",
            dtdz: "",
            shengName: "",
            shiName: "",
            xianName: "",
            dialogMap: false,
            flag: "pc"
        };
    },
    mounted() {
        if (this.isMobile()) {
            // 手机端
            sessionStorage.setItem("flag", "app");
            this.flag = "app";
        } else {
            // pc端
            sessionStorage.setItem("flag", "pc");
            this.flag = "pc";
        }
        // if (this.inout != "" && this.inout != undefined && this.inout != null) {
        //     this.inout = 1;
        //     this.guo();
        // }
        // if (this.data.sheng != "" && this.data.sheng != undefined && this.data.sheng != null) {
        //     this.zhen = this.data.zhen;
        //     this.dizhi = this.data.dizhi;
        //     this.dtdz = this.data.dtdz;
        //     this.key = this.data.key;
        //     this.shengName = this.data.sheng;
        //     this.shiName = this.data.shi;
        //     this.xianName = this.data.xian;
        //     this.getSheng();
        // }
        if (sessionStorage.getItem("memberType") == "Add") {
            this.guo();
        }
    },
    methods: {
        isMobile() {
            let flag = navigator.userAgent.match(
                /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
            );
            return flag;
        },
        guo() {
            this.shengData = [];
            this.shiData = [];
            this.xianData = [];
            this.sheng = "";
            this.shi = "";
            this.xian = "";
            this.shengName = "";
            this.shiName = "";
            this.xianName = "";
            this.getSheng();
            this.emit();
        },
        // 获取省
        getSheng() {
            if (this.inout != "" && this.inout != undefined && this.inout != null) {
                api.getSheng(this.inout).then((res) => {
                    this.shengData = res.data;
                    this.sheng = "";
                    for (let i = 0; i < res.data.length; i++) {
                        if (this.shengName == res.data[i].name) {
                            this.sheng = res.data[i].id;
                            this.shengName = res.data[i].name;
                            this.getShi();
                        }
                    }
                });
            }
        },
        // 获取市
        getShi() {
            // if (this.sheng != '' && this.inout!='') {
            if (
                this.sheng != "" &&
                this.sheng != undefined &&
                this.sheng != null &&
                this.inout != "" &&
                this.inout != undefined &&
                this.inout != null
            ) {
                api.getShi({ type: this.inout, id: this.sheng }).then((res) => {
                    this.shiData = res.data;
                    this.shi = "";
                    // if (this.data != undefined) {
                    for (let i = 0; i < res.data.length; i++) {
                        if (this.shiName == res.data[i].name) {
                            this.shi = res.data[i].id;
                            this.shiName = res.data[i].name;
                            this.getXian();
                        }
                    }
                    // }
                });
            }
        },
        // 获取县/区
        getXian() {
            if (this.shi != "" && this.shi != undefined && this.shi != null) {
                api.getXian(this.shi).then((res) => {
                    this.xianData = res.data;
                    this.xian = "";
                    // if (this.data != undefined) {
                    for (let i = 0; i < res.data.length; i++) {
                        if (this.xianName == res.data[i].name) {
                            this.xian = res.data[i].id;
                            this.xianName = res.data[i].name;
                        }
                    }
                    // }
                });
            }
        },
        shengChage(e) {
            for (const key in this.shengData) {
                if (this.shengData[key].id == e) {
                    this.shengName = this.shengData[key].name;
                    this.dizhi = this.shengName;
                }
            }
            this.shi = "";
            this.xian = "";
            this.emit();
            this.getShi();
        },
        shiChage(e) {
            // this.shiData.forEach((item) => {
            //     if (item.id == e) {
            //         this.shiName = item.name;
            //         this.dizhi = this.shengName + this.shiName;
            //     }
            // });
            for (const key in this.shiData) {
                if (this.shiData[key].id == e) {
                    this.shiName = this.shiData[key].name;
                    this.dizhi = this.shengName + this.shiName;
                }
            }
            this.xian = "";
            this.emit();
            this.getXian();

            this.getCoordinate();
        },
        xianChage(e) {
            // this.xianData.forEach((item) => {
            //     if (item.id == e) {
            //         this.xianName = item.name;
            //         this.dizhi = this.shengName + this.shiName + this.xianName;
            //     }
            // });
            for (const key in this.xianData) {
                if (this.xianData[key].id == e) {
                    this.xianName = this.xianData[key].name;
                    this.dizhi = this.shengName + this.shiName + this.xianName;
                }
            }
            this.emit();
            this.getCoordinate();
        },
        zhenChage(e){
          this.dizhi = this.shengName + this.shiName + this.xianName + this.zhen;
          this.emit();
        },
        handlerChange(e) {
            this.emit();
        },
        getCoordinate() {
            if (this.sheng != "" && this.shi != "") {
                api.getCoordinate(
                    this.$qs.stringify({
                        type: this.inout,
                        sheng: this.shengName,
                        shi: this.shiName,
                        xian: this.xianName
                    })
                ).then((res) => {
                    this.dtdz = res.data;
                });
            }
        },
        emit() {
            let data = {
                inout: this.inout,
                sheng: this.shengName,
                shi: this.shiName,
                xian: this.xianName,
                zhen: this.zhen,
                dizhi: this.dizhi,
                key: this.propskey,
                keyType: this.propskeyType,
                keyInd: this.propskeyInd,
                dtdz: this.dtdz
            };
            this.$emit("area", data);
        },
        mapFun() {
            this.$emit("map", this.dizhi, this.propskey);
        },
        //地图定位
        mapOpen() {
            this.dialogMap = true;
        },
        getPosi(lng, lat, address) {
            this.dtdz = lng + ", " + lat;
            this.dizhi = address;
            this.dialogMap = false;
            this.emit();
            // this.$set(this.ruleForm, this.maKkey, );
            // this.$set(this.ruleForm, "czzdydz", address);
        }
    },
    components: {
        vmap
    },
    computed: {
        changeData() {
            const { inout, zhen, dizhi } = this;
            return {
                inout,
                zhen,
                dizhi
            };
        }
    },
    watch: {
        // data: {
        //     handler(val) {
        //         this.inout = this.data.inorout || 1;
        //         this.zhen = this.data.zhen;
        //         this.dizhi = this.data.dizhi;
        //         this.dtdz = this.data.dtdz;
        //         this.key = this.data.key;
        //         this.shengName = this.data.sheng;
        //         this.getSheng();
        //         this.shiName = this.data.shi;
        //         this.getShi();
        //         this.xianName = this.data.xian;
        //         this.getXian();
        //     },
        //     immediate: true
        // },
        propsinorout: {
            handler(newVal, oldVal) {
                this.inout = newVal || 1;
            },
            immediate: true
        },
        propssheng: {
            handler(newVal, oldVal) {
                this.getSheng();
                if (newVal != oldVal) {
                    this.shengName = newVal;
                }
                if (!newVal) {
                    this.sheng = "";
                }
            },
            immediate: true
        },
        propsshi: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.shiName = newVal;
                    if (this.shiData.length == 0) {
                        this.getShi();
                    }
                }
                if (!newVal) {
                    this.shi = "";
                }
            },
            immediate: true
        },
        propsxian: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.xianName = newVal;
                    if (this.xianData.length == 0) {
                        this.getXian();
                    }
                }
                if (!newVal) {
                    this.xian = "";
                }
            },
            immediate: true
        },
        propszhen: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.zhen = newVal;
                }
            },
            immediate: true
        },
        propsdizhi: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.dizhi = newVal;
                }
            },
            immediate: true
        },
        propsdtdz: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.dtdz = newVal;
                }
            },
            immediate: true
        },
        propsdtdz: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.dtdz = newVal;
                }
            },
            immediate: true
        }
    }
};
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/area.vue